import { ROUTE_NAMES } from './routeNames.const'

export const routeAdvisorPatrimony = {
  path: '/advisor-patrimony/',
  name: ROUTE_NAMES.advisorPatrimony,
  component: () =>
    import(
      /* webpackChunkName: "AdvisorPatrimony" */ 'src/pages/AdvisorPatrimony/AdvisorPatrimony.vue'
    ),
}
